import { Component, Directive, ElementRef, Injector, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'faqs-list-directive',
    standalone: false,
})
export class FaqsListDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('faqsList', elementRef, injector);
        console.log("FaqsListDirective initialized");
    }
}

@Component({
    selector: 'faqs-list',
    template: '<faqs-list-directive></faqs-list-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaqsListComponent {
    constructor() {
        console.log("FaqsListComponent initialized");
    }
}

@Directive({
    selector: 'faq-form-directive',
    standalone: false,
})
export class FaqFormDirective extends UpgradeComponent {
    @Input() faqId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('faqForm', elementRef, injector);
        console.log("FaqFormDirective initialized");
    }
}

@Component({
    selector: 'faq-form',
    template: '<faq-form-directive [faqId]="faqId"></faq-form-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaqFormComponent implements OnInit {
    @Input() faqId: string = 'new';
    
    constructor(private route: ActivatedRoute) {}
    
    ngOnInit() {
        // Subscribe to route params to get the FAQ ID
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.faqId = params['id'];
                console.log("FaqFormComponent initialized with faqId:", this.faqId);
            }
        });
    }
}
